import React from 'react';
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './featuring_vendors.css'; // We will create this file next
import { FaStar, FaMapMarkerAlt, FaCrown, FaInfoCircle } from 'react-icons/fa'; // Import icons

const FeaturingVendors = () => {
    const demoVendors = [
        {
            id: 1,
            name: 'SSS Stories',
            imageUrl: 'https://wedstra25.s3.eu-north-1.amazonaws.com/67f20a67507a862158fb9f91/documents//Electricity Bill_aadharCard.png', // Replace with an actual image
            rating: 4.8,
            reviews: 89,
            address: '67f20a67507a862158fb9f92', // Example address/ID
            type: 'Venue',
            price_per_day: '60,000',
            isPremium: true // Example for premium status
        },
        {
            id: 2,
            name: 'Candid Photography',
            imageUrl: 'https://wedstra25.s3.eu-north-1.amazonaws.com/67f20a67507a862158fb9f91/documents//Electricity Bill_aadharCard.png',
            rating: 4.5,
            reviews: 120,
            address: 'Pune, Maharashtra',
            type: 'Photographer',
            price_per_day: '45,000',
            isPremium: false
        },
        {
            id: 3,
            name: 'Event Planners Inc.',
            imageUrl: 'https://wedstra25.s3.eu-north-1.amazonaws.com/67f20a67507a862158fb9f91/documents//Electricity Bill_aadharCard.png',
            rating: 4.9,
            reviews: 75,
            address: 'Mumbai, Maharashtra',
            type: 'Planner',
            price_per_day: '1,20,000',
            isPremium: true
        },
        {
            id: 4,
            name: 'Elegant Decorators',
            imageUrl: 'https://wedstra25.s3.eu-north-1.amazonaws.com/67f20a67507a862158fb9f91/documents//Electricity Bill_aadharCard.png',
            rating: 4.7,
            reviews: 95,
            address: 'Delhi, India',
            type: 'Decorator',
            price_per_day: '80,000',
            isPremium: false
        },
        // You can add more vendors here and the slider will adapt
    ];

    // 2. Settings for the react-slick slider
    const settings = {
        dots: false, // Changed to false as per image
        infinite: false,
        speed: 500,
        slidesToShow: 4, // Shows 4 cards on desktop
        slidesToScroll: 1,
        prevArrow: <SamplePrevArrow />, // Custom previous arrow
        nextArrow: <SampleNextArrow />, // Custom next arrow
        responsive: [
            {
                breakpoint: 1200, // For smaller desktops
                settings: {
                    slidesToShow: 3,
                }
            },
            {
                breakpoint: 992, // For tablets
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 768, // For mobile devices
                settings: {
                    slidesToShow: 1,
                }
            }
        ]
    };

    // Custom Arrow Components (optional, but good for styling)
    function SampleNextArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", background: "lightgray", borderRadius: "50%" }}
                onClick={onClick}
            />
        );
    }

    function SamplePrevArrow(props) {
        const { className, style, onClick } = props;
        return (
            <div
                className={className}
                style={{ ...style, display: "block", background: "lightgray", borderRadius: "50%" }}
                onClick={onClick}
            />
        );
    }

    return (
        <section className="featured-vendors-section m-auto p-0">
            <h2 className="section-title mb-3">Featuring Vendors</h2>
            <Slider {...settings}>
                {/* 3. Map over the demo data to create a card for each vendor - UPDATED JSX */}
                {demoVendors.map((vendor) => (
                    <div key={vendor.id} className="vendor-card-wrapper">
                        <div className="vendor-card">
                            <div className="vendor-image-container">
                                <img
                                    src={vendor.imageUrl}
                                    alt={vendor.name}
                                    className="vendor-image"
                                />
                            </div>
                            <div className="vendor-card-content">
                                <h3 className="vendor-name">{vendor.name}</h3>
                                <div className="vendor-rating">
                                    <FaStar className="star-icon" /> {vendor.rating} ({vendor.reviews} reviews)
                                </div>
                                <p className="vendor-address">
                                    <FaMapMarkerAlt className="location-icon" /> {vendor.address}
                                </p>
                                <p className="vendor-type">{vendor.type}</p>
                                <p className="vendor-price">₹ {vendor.price_per_day} <span className="per-day">per day</span></p>
                                {/* Removed the "Learn More" button as it's not in the example image */}
                            </div>
                        </div>
                    </div>
                ))}
            </Slider>
        </section>
    );
};

export default FeaturingVendors;